import EachWeekDay from './EachWeekDay';
export default EachWeekDay;
